var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{attrs:{"id":"routerView"}},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2",attrs:{"id":"ticket_default"}},[_c('div',{staticClass:"float-left"})])
}]

export { render, staticRenderFns }